import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';
import { MonitoringConfig } from 'softcat:config/monitoring.ts';
import { PiqEnvironment } from 'softcat:config/piq-environment.ts';

const initialiseGoogleAnalytics = () => {
    const mode = import.meta.env.MODE;
    const isLocalOrTest = mode === 'development' || mode === 'test';

    return ReactGA.initialize(MonitoringConfig.GoogleAnalyticsId, {
        testMode: isLocalOrTest,
    });
};

const initialiseSentry = (mode: string, environment: PiqEnvironment) => {
    const isLocalOrTest = mode === 'development' || mode === 'test';
    const isProductionEnvironment = environment === PiqEnvironment.PRODUCTION;

    let samplingRate = isLocalOrTest ? 0 : 0.1;

    if (isProductionEnvironment) {
        samplingRate = 0.2;
    }

    return Sentry.init({
        dsn: isLocalOrTest ? '' : MonitoringConfig.SentryDsn,
        environment: isLocalOrTest ? 'localhost' : `PIQ | ${environment}`,
        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                createRoutesFromChildren,
                matchRoutes,
                useEffect,
                useLocation,
                useNavigationType,
            }),
            Sentry.replayIntegration(),
        ],
        release: import.meta.env.VITE_SENTRY_RELEASE_VERSION,
        replaysOnErrorSampleRate: isProductionEnvironment ? 0.2 : 0,
        replaysSessionSampleRate: 0,
        tracesSampleRate: samplingRate,
    });
};

export const MonitoringUtils = {
    initialiseGoogleAnalytics,
    initialiseSentry,
};
